import { render } from "./InstanceLeftMenuAction.vue?vue&type=template&id=50f2b929&scoped=true"
import script from "./InstanceLeftMenuAction.vue?vue&type=script&lang=js"
export * from "./InstanceLeftMenuAction.vue?vue&type=script&lang=js"

import "./InstanceLeftMenuAction.vue?vue&type=style&index=0&id=50f2b929&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f2b929"]])

export default __exports__